// one release per entry, newest first. English only, on purpose: the notes are read once and
// dated, not worth five translations. `icon` names an entry of the page's icon map, `badge` adds a small mark next to an item's title, `tags` sit next to the release title, `short` is the sidebar mark
const patchNotes = [
  {
    id: '2026-09',
    title: 'September 2026 release',
    short: 'Sep 2026',
    tags: ['AI translation', 'Images', 'Usability'],
    items: [
      {
        icon: 'ai',
        title: 'AI bulk translation',
        badge: 'Closed beta',
        text: 'Bulk translate whole sections with AI instead of a machine translation service, without spending words. Available to the Growth and Premium plans as a closed beta. Contact support if you would like to take part.',
      },
      {
        icon: 'image',
        title: 'Image translation',
        text: 'Besides uploading a translated image you can now pick one from your library. Image rows show a thumbnail in the theme, metafields and metaobjects sections, and a side-by-side view lets you compare and step through the images.',
      },
      {
        icon: 'altText',
        title: 'Image alt texts',
        text: 'The alt texts of images on products, collections and articles can now be translated through Shopify\'s native translation, right in their sections. Until now this took a workaround via custom content.',
      },
      {
        icon: 'machineTranslation',
        title: 'Machine translation details',
        text: 'A dialog before every run lists the fields, the word count and the cost. Include or exclude single fields; glossary hits are marked per row.',
      },
      {
        icon: 'fieldMenu',
        title: 'Field menu on every row',
        text: 'The menu that appeared when hovering over the arrow between two fields has moved into a three-dot menu to the right of the fields. Clear a translation or machine translate a single field from there, image rows included.',
      },
      {
        icon: 'sort',
        title: 'Lists keep their order',
        text: 'A list sorted by progress no longer reorders itself while you work: an item stays in place when you open or save it, and after a machine translation run. Choose "Re-apply sort" in the sort menu when you want the current progress to order the list again.',
      },
      {
        icon: 'templates',
        title: 'Theme sections by template',
        text: 'Filter a theme\'s sections by template, ideal for large themes.',
      },
      {
        icon: 'markup',
        title: 'Markup check for theme translations',
        text: 'Saved translations are checked for broken markup. "Show markup problems" in the section menu lists them.',
      },
      {
        icon: 'bulkDelete',
        title: 'Custom content',
        text: 'Delete several fields at once, available in the three-dot menu of a subsection.',
      },
      {
        icon: 'adminLink',
        title: 'Open in Shopify admin',
        text: 'Products, pages, articles, blogs, collections and metaobjects have a link in their three-dot menu to their page in the Shopify admin.',
      },
      {
        icon: 'darkMode',
        title: 'Dark mode',
        text: 'Refined surfaces, banners and loading states.',
      },
      {
        icon: 'texts',
        title: 'German and Spanish UI texts',
        text: 'Revised throughout, now in the informal address.',
      },
    ],
  },
];

export default patchNotes;
